import React from "react";

function LaserDentistry() {
  return <div>Laser Dentistry</div>;
}

export default LaserDentistry;
